import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import MultiSelect from '../common/MultiSelect';
import TreeMultiSelect from '../common/TreeMultiSelect';
import SortingPopover, { SortingContent } from '../SortingPopover';
import FiltersPopover from '../FiltersPopover';
import CollectionUtil from './../queries/lightbox/CollectionUtil';
import Storage from '../protocol/Storage';
import LayoutControls from '../common/LayoutControls';
import Button from '../common/Button';
import Div from '../common/elements/Div';
import { getScreenSize, ScreenSize, isXsScreen, isMobile, getInnerWidth } from '../util/ScreenUtil';
import ActionSheet from '../common/ActionSheet';
import Row from '../common/layout/Row';
import MobilePopover from '../common/MobilePopover';
import { CategoryWiseDetail, CurrentContextInfo, RepoItem } from '../autogenerated/ZoomBridge';
import ActionMenu from '../common/ActionMenu';
import Switch from '../common/form/Switch';
import Store from '../store/Store';
import {
  SHOW_TREE_VIEW,
  SHOW_FOLDERNAV_VIEW,
  MODE,
  LOADED_TREE_ITEMS,
  SHOW_UPLOADS,
  BREADCRUMB_ASSETS,
  GLOBAL_SEARCH_INFO,
  ALL_FILES_OPTION
} from '../store/Constants';
import Breadcrumb from '../common/Breadcrumb';
import Center from '../common/layout/Center';
import ViewUtil from '../ViewUtil';
import t from '../i18n/I18n';
import { ThemeSetup } from '../themes/ThemeSetup';
import uploadAssets from '../upload/uploadAssets';
import { canUseModernUploader, getFileNodesFromDropEvent } from '../util/DndUtilModern';
import { getFilesFromDropEvent } from '../util/DndUtil';
import { getRemotePathFromBreadcrumb } from '../store/StoreUtil';
import System from '../basic/System';

import './AssetsListHeader.css';
import SaveSettings from '../queries/settings/SaveSettings';
import { getAssetProps } from '../util/SelectedItemUtil';
import { BACK_TO_BTN, KeyCode, UPLOAD_FROM_COMPUTER, UPLOAD_FROM_URL } from '../util/Constants';
import ToolTip from '../common/AssetPropertyView';
import KeyboardShortcuts from '../keyboard-shortcuts/KeyboardShortcuts';
import KeydownConfig from '../keyboard-shortcuts/KeydownConfig';
import FileInfoUtil from '../util/FileInfoUtil';
import { getBackToSrchBtn, setBackToSrchBtn } from '../util/LocalStorageUtil';

function isBlacklisted(category: CategoryWiseDetail) {
  const blacklistIds = ['project_name'];
  return _.includes(blacklistIds, category.getCategoryId());
}

type Props = {
  assets: RepoItem[],
  selectedItems: number[],
  totalCount: number,
  categoryList: CategoryWiseDetail[],
  contextInfo: CurrentContextInfo,
  layout: any,
  scale: any,
  emptyPrompt: any,
  mobileEditMode: boolean,
  onSortCriteriaChanged: Function,
  onConfigureClick: Function,
  onRefreshClick: Function,
  issueApplyFilter: Function,
  onAddClick: Function,
  onEditClick: Function,
  onDeleteClick: Function,
  onScaleChange: Function,
  onLayoutChange: Function,
  resetFilters: Function,
  onToggleMobileEditModeClick: Function,
  onCategoryChange: Function,
  onFilterChange: Function,
  onSelectAllItems: Function,
  onDownloadClick: Function,
  onClearSelectedItemsClick: Function,
  onNewFolderClick: Function,
  showFolderNavView: boolean,
  showTreeView: boolean,
  globalSearchInfo: Object,
  resetExpandedNodes: boolean,
  setAssetsEmpty: Function,
  onSearchInput: Function,
  assetsListBlockNode: ?HTMLDivElement,
  widthOfFolderNav: number,
  setUploadModal: Function,
  header_Style: {
    width: String,
    left: string
  }
};

type State = {
  showActionSheet: boolean,
  fileTypes: Object[],
  fileType: ?string
};

export default class AssetsListHeader extends React.Component<Props, State> {
  state = {
    showActionSheet: false,
    fileTypes: [],
    fileType: null,
    selectedAssetsContainFolder: false,
    inSearchEnable: false
  };
  componentDidMount() {
    this.setFolderNavView();
    this.props.assetsListBlockNode ? this.props.assetsListBlockNode.classList.remove('sticky', 'mobile') : '';

    this.delayedCallback = _.debounce(function(value) {
      this.props.onSearchInput(value);
    }, 500);
  }

  componentWillUpdate() {
    this.setFolderNavView();
  }

  setFolderNavView = () => {
    const { showFolderNavView, mobileEditMode } = this.props;
    if (showFolderNavView && isMobile()) {
      Store.put(SHOW_FOLDERNAV_VIEW, !showFolderNavView);
      Store.put(SHOW_TREE_VIEW, !showFolderNavView);
    }
  };

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.assets.length !== this.props.assets.length) {
      const { assets } = nextProps;
      const set = new Set();
      assets.forEach((a) => set.add(a.getBasicFileAttributes().getMediaType()));
      set.delete('NONE');
      const fileTypes = Array.from(set).map((type) => ({ value: type, label: _.capitalize(type) }));
      this.setState({ fileTypes });
    }
  }
  componentDidUpdate(prevProps: Props) {
    if (prevProps.selectedAssets.length != this.props.selectedAssets.length) {
      this.setState({
        selectedAssetsContainFolder: getAssetProps(this.props.selectedAssets).containsFolder
      });
    }
  }

  onSearchActive = (isActive) => {
    this.setState({ inSearchEnable: isActive });
  };

  setThumbScaleState(value) {
    Storage.set('THUMBSCALE_ASSETS', value);
    this.setState({ thumbScale: value });
  }

  /**
   *
   * @param {CategoryWiseDetail} category
   * @param {number} index
   */
  renderFilter(category: CategoryWiseDetail) {
    const { categoryList, globalSearchInfo, showFolderNavView, onCategoryChange, resetExpandedNodes } = this.props;
    if (showFolderNavView && !globalSearchInfo.active && isBlacklisted(category)) {
      return null;
    }

    if (!category.isRecursiveData())
      return <MultiSelect category={category} key={category.getReactKey()} onCategoryChangeEvent={onCategoryChange} />;
    else
      return (
        <TreeMultiSelect
          category={category}
          categoryList={categoryList}
          key={category.getReactKey()}
          onCategoryChangeEvent={onCategoryChange}
          resetExpandedNodes={resetExpandedNodes}
        />
      );
  }

  onSearchInputChange = (value) => {
    this.delayedCallback(value);
  };

  toggleActionSheet = () => {
    this.setState({ showActionSheet: !this.state.showActionSheet });
  };

  toggleTreeView = () => {
    const { showTreeView } = this.props;
    Store.put(SHOW_TREE_VIEW, !showTreeView);
    //Storage.set(SHOW_TREE_VIEW, !showTreeView);
    // ViewUtil.setTreeView(!showTreeView);
    this.saveSettings();
  };

  toggleFolderNav = async () => {
    const { showFolderNavView, showTreeView, setAssetsEmpty } = this.props;
    Store.put(SHOW_FOLDERNAV_VIEW, !showFolderNavView);
    await this.props.resetFilters();
    if (showFolderNavView === true) Store.put(SHOW_TREE_VIEW, false);
    this.saveSettings();
    // Storage.set(SHOW_FOLDERNAV_VIEW, !showFolderNavView);
    // if (showFolderNavView) {
    //   ViewUtil.setPwd(null);
    // }
    // ViewUtil.setFolderNavView(!showFolderNavView, !showFolderNavView);
    setAssetsEmpty();
  };

  saveSettings = () => {
    let mode = 'SEARCH';
    const treeview = Store.get(SHOW_TREE_VIEW);
    const folderNav = Store.get(SHOW_FOLDERNAV_VIEW);
    if (folderNav) mode = 'FOLDERNAV';
    if (treeview) mode = 'TREE';
    Store.put(LOADED_TREE_ITEMS, null);
    SaveSettings.save(MODE, mode);
  };

  renderSort = () => {
    const { contextInfo, onSortCriteriaChanged } = this.props;

    return (
      <SortingContent
        values={CollectionUtil.ASSET_SORT_PARAMS.SORT_CRITERIAS}
        selected={contextInfo.getSortCriteria()}
        onClick={onSortCriteriaChanged}
        selectedOrder={contextInfo.getOrder()}
        showOrder
      />
    );
  };

  renderBulkActions = () => {
    const { onEditClick, onDeleteClick, onSelectAllItems, onAddClick } = this.props;

    const children = (
      <div className="bulk-actions">
        <Button text={t('SELECT_ALL')} onClick={onSelectAllItems} />
        <Button
          icon={ThemeSetup.getImageURL('edit_asset.svg')}
          text="Edit"
          title={t('EDIT_METADATA')}
          onClick={onEditClick}
        />
        <Button
          icon={ThemeSetup.getImageURL('img.svg')}
          title={t('ADD_TO_COLLECTION')}
          text={t('ADD_TO_COLLECTION')}
          onClick={onAddClick}
        />
        <Button
          icon={ThemeSetup.getImageURL('delete_asset.svg')}
          title={t('DELETE_LABEL')}
          text="Delete"
          onClick={onDeleteClick}
        />
      </div>
    );

    return isXsScreen() ? <MobilePopover vertical>{children}</MobilePopover> : children;
  };

  renderLayoutControls = () => {
    const { scale, layout, onScaleChange, onLayoutChange } = this.props;

    return (
      <LayoutControls
        layout={layout}
        scale={scale}
        sliderProps={{ min: '.5', max: '1.1', step: 'any' }}
        onLayoutChange={onLayoutChange}
        onScaleChange={onScaleChange}
      />
    );
  };
  browseFiles = () => {
    this._filesInput.click();
  };
  onChangeFileInput = async (e) => {
    const isModern = canUseModernUploader(e);
    const files = isModern ? await getFileNodesFromDropEvent(e) : await getFilesFromDropEvent(e);
    this.setState({ isOver: false });

    if (!files.length) {
      debug('[onChange()] no files. return');
      return;
    }

    let projectName: string;
    let uploadPath: string;
    const pwd: number[] = ViewUtil.getPwd();
    if (_.size(pwd) > 0) {
      const breadCrumAssets = _.size(pwd) > 0 ? Store.get(BREADCRUMB_ASSETS) : undefined;
      const projectRepoItem: RepoItem = _.head(breadCrumAssets); //Store.get(BREADCRUMB_ASSETS)[0].getName();
      if (projectRepoItem) {
        projectName = !this.props.showFolderNavView ? '' : projectRepoItem.getName();
        uploadPath = !this.props.showFolderNavView ? '' : getRemotePathFromBreadcrumb();
      }
    }
    uploadAssets(files, { isModernUpload: isModern, projectName: projectName, uploadPath: uploadPath });
    if (!System.isDesktop()) {
      Store.put(SHOW_UPLOADS, true);
    }
    this._filesInput.value = null;
  };

  browseFiles = () => {
    this._filesInput.click();
  };

  isRootDir = () => {
    let isRoot = Store.get(GLOBAL_SEARCH_INFO).active ? false : ViewUtil.getPwd().length === 0;
    if (Store.get(ALL_FILES_OPTION) || !Store.get(SHOW_FOLDERNAV_VIEW)) {
      isRoot = false;
    }
    return isRoot;
  };

  getHeaderWidth = () => {
    const { showTreeView, widthOfFolderNav } = this.props;
    const innerWidth = getInnerWidth();
    if (showTreeView) {
      return innerWidth - widthOfFolderNav ? widthOfFolderNav : 240;
    } else return innerWidth;
  };

  renderStandardHeader = () => {
    const {
      assets,
      totalCount,
      selectedItems,
      categoryList,
      contextInfo,
      layout,
      scale,
      onRefreshClick,
      issueApplyFilter,
      resetFilters,
      onLayoutChange,
      onScaleChange,
      onSortCriteriaChanged,
      onConfigureClick,
      onAddClick,
      onEditClick,
      onDeleteClick,
      onDownloadClick,
      onClearSelectedItemsClick,
      onNewFolderClick,
      showFolderNavView,
      showTreeView,
      globalSearchInfo,
      assetsListBlockNode,
      setUploadModal,
      header_Style
    } = this.props;
    const isRootDir = this.isRootDir();
    if (assetsListBlockNode) {
      const sticky = assetsListBlockNode.classList.contains('sticky');
      if (sticky) assetsListBlockNode.classList.remove('mobile');
    }
    const styles = getStyle();
    const configureIconStyle = { ...styles.configure };
    if (this.state.view === 'MOSAIC') {
      configureIconStyle.width = 0;
      configureIconStyle.marginLeft = 0;
    }

    const hasDirtyFilters = (categoryList || []).filter((category) => category.isHasAnySelectedItem()).length > 0;
    const headerWidth = this.getHeaderWidth();
    const isHeaderWidthGreaterThan = headerWidth > 1500 ? true : false;
    const backBtnLabel = getBackToSrchBtn()=== BACK_TO_BTN.ADVANCED_SRCH ? t('BACK_TO_ADVANCED_SEARCH') : t('BACK_TO_SEARCH');
    const h2_style = {
      width: header_Style.width,
      left: header_Style.left
    };
    return (
      <div
        className="assets-tab"
        name="AssetsListHeader"
        style={{
          position: 'sticky',
          left: 0,
          zIndex: 2,
          padding: !showTreeView ? '0 20px 0 20px' : null
        }}>
        <input
          ref={(node) => (this._filesInput = node)}
          accept="*\*"
          type="file"
          style={{ position: 'fixed', top: '-1000px' }}
          onChange={(e) => this.onChangeFileInput(e)}
          multiple
        />
        {globalSearchInfo.active ? (
          <div className="search-header">
            {t('SEARCH_RESULTS', {
              searchString: globalSearchInfo.searchString ? globalSearchInfo.searchString : 'all'
            })}
          </div>
        ) : (
          <div className='flex-row container-h1'>
            <Breadcrumb showFolderNavView={showFolderNavView} />
            {/* {globalSearchInfo.assets || getBackToSrchBtn()===BACK_TO_BTN.ADVANCED_SRCH ?
              <div className='flex-row back-btn-container'><Button className="back" type="CAPS"  icon={ThemeSetup.getImageURL("arrow_left.svg")} onClick={()=>{
                if(backBtnLabel===t('BACK_TO_ADVANCED_SEARCH')) {
                  setBackToSrchBtn(null);
                  ViewUtil.switchToAdvancedSearch();
                } else {
                  onRefreshClick();
                  Store.put(GLOBAL_SEARCH_INFO, {...globalSearchInfo, active: true});
                }
              }}>
                {backBtnLabel}
              </Button></div>: null} */}
          </div>

        )}
        {_.isEmpty(categoryList) ? (
          <div style={{ height: 74 }} />
        ) : (
          <div
            className="header-1"
            style={{
              borderBottom: '1px solid var(--separator-color)',
              paddingBottom: '15px',
              overflow: 'hidden'
            }}>
            <div className=" align-center" style={{ maxWidth: '85%' }}>
              {categoryList.map((category: CategoryWiseDetail, index: number) => this.renderFilter(category, index))}
              {hasDirtyFilters ? (
                <Button
                  onClick={resetFilters}
                  title={t('CLEAR_ALL_FILTERS')}
                  style={{
                    marginLeft: 10,
                    color: 'var(--primary-style-color)',
                    textDecoration: 'underline'
                  }}>
                  {t('CLEAR_ALL_FILTERS')}
                </Button>
              ) : null}
            </div>
            <div>
              <FiltersPopover issueApplyFilter={issueApplyFilter} />
            </div>
          </div>
        )}
        <div name="header-md"></div>
        <div className="header-2" style={h2_style}>
          <div
            className="header-2-content flex-row align-center spc-between"
            style={!showTreeView ? { maxWidth: '100%' } : null}>
            {selectedItems.length > 0 ? (
              <div style={{ fontSize: 14 }}>
                {selectedItems.length}{' '}
                {selectedItems.length === 1 ? <span>{t('ASSET')}</span> : <span>{t('ASSETS')}</span>} {t('SELECTED')}
                <span
                  style={{
                    cursor: 'pointer',
                    color: 'var(--primary-style-color)',
                    textDecoration: 'underline',
                    paddingLeft: '3px'
                  }}
                  onClick={onClearSelectedItemsClick}>
                  ({t('CLEAR')})
                </span>
              </div>
            ) : (
              <div className="d-flex">
                {
                  // assets.length > 0 ?
                  <div style={{ display: 'inline-flex', position: 'relative', width: 'auto' }}>
                    {
                      <span style={{marginRight: 5}}>
                        {assets.length}/{totalCount}
                      </span>
                    }
                    {assets.length === 1 ? <span>{t('ASSET')}</span> : <span>{t('ASSETS')}</span>}
                    <Button
                      icon="images/refresh.svg"
                      title={t('REFRESH')}
                      style={styles.refresh}
                      onClick={onRefreshClick}
                    />
                  </div>
                  // : (
                  //   <div style={{ height: 19 }} />
                  // )
                }
              </div>
            )}
            {!this.state.inSearchEnable ? (
              <div className="center-actions">
                {selectedItems.length > 0 ? (
                  <div
                    className="bulk-actions flex-row align-center actions"
                    style={this.state.selectedAssetsContainFolder ? { flexBasis: 80 } : {}}>
                    {!this.state.selectedAssetsContainFolder ? (
                      <Button
                        icon={ThemeSetup.getImageURL('img.svg')}
                        text={isHeaderWidthGreaterThan ? t('ADD_TO_COLLECTION') : null}
                        title={t('ADD_TO_COLLECTION')}
                        onClick={onAddClick}
                        type="link"
                      />
                    ) : null}
                    <Button
                      icon={ThemeSetup.getImageURL('share_asset.svg')}
                      text={isHeaderWidthGreaterThan ? t('SHARE_AND_DOWNLOAD') : null}
                      tooltipStyle={!isHeaderWidthGreaterThan ? { marginLeft: 0 } : {}}
                      title={t('SHARE_AND_DOWNLOAD')}
                      onClick={onDownloadClick}
                      type="link"
                    />
                    {!this.state.selectedAssetsContainFolder ? (
                      <Button
                        icon={ThemeSetup.getImageURL('edit_asset.svg')}
                        text={isHeaderWidthGreaterThan ? t('EDIT_METADATA') : ''}
                        title={t('EDIT_METADATA')}
                        tooltipStyle={!isHeaderWidthGreaterThan ? { marginLeft: 0 } : {}}
                        onClick={onEditClick}
                        type="link"
                      />
                    ) : null}
                    <Button
                      icon={ThemeSetup.getImageURL('delete_asset.svg')}
                      text={isHeaderWidthGreaterThan ? t('DELETE_LABEL') : ''}
                      title={t('DELETE_LABEL')}
                      tooltipStyle={!isHeaderWidthGreaterThan ? { marginLeft: 0 } : {}}
                      onClick={onDeleteClick}
                      type="link"
                    />
                  </div>
                ) : (
                  <div className="uploadOption">
                    {!showFolderNavView || ViewUtil.getPwd().length && !globalSearchInfo.active  ? (
                      <React.Fragment>
                        <ToolTip>
                          <ActionMenu
                            icon={ThemeSetup.getImageURL('upload_asset.svg')}
                            title={t('UPLOAD')}
                            text={headerWidth > 1000 && !this.state.inSearchEnable ? t('UPLOAD') : null}
                            buttonType="link"
                            // theme="WHITE"
                            // anchor="CENTER"
                            dismissOnClick>
                            <div className="uploadPopupMain">
                              <Button
                                type="PLAIN"
                                text={t('UPLOAD_FROM_COMPUTER')}
                                onClick={() => this.browseFiles()}
                              />
                              <Button
                                type="PLAIN"
                                text={!this.state.inSearchEnablet && t('UPLOAD_FROM_URL')}
                                onClick={() => setUploadModal(UPLOAD_FROM_URL)}
                              />
                            </div>
                          </ActionMenu>
                        </ToolTip>
                      </React.Fragment>
                    ) : // <Button
                    //   icon={ThemeSetup.getImageURL('upload_asset.svg')}
                    //   text={headerWidth > 1000 ? t('UPLOAD') : null}
                    //   title={t('UPLOAD')}
                    //   onClick={() => this.browseFiles()}
                    //   type="link"
                    // />
                    null}
                    {globalSearchInfo.active || !ViewUtil.getPwd().length || !showFolderNavView ? null : (
                      <Button
                        icon={ThemeSetup.getImageURL('add_asset_red.svg')}
                        text={
                          !this.props.showNotification && headerWidth > 1000 && !this.state.inSearchEnable
                            ? t('NEW_FOLDER')
                            : null
                        }
                        title={t('NEW_FOLDER')}
                        onClick={onNewFolderClick}
                        type="link"
                        tooltipStyle={headerWidth > 1000 ? { marginLeft: 30 } : null}
                        style={
                          this.props.showNotification
                            ? {
                                position: 'absolute',
                                marginTop: '-10px'
                              }
                            : null
                        }
                      />
                    )}
                  </div>
                )}
              </div>
            ) : null}

            {
              // assets.length === 0 ? null :

              <div className="flex-row align-center">
                {!isRootDir ? (
                  <InputSearch
                    onInput={this.onSearchInputChange}
                    onSearchActive={this.onSearchActive}
                    searchInput={this.props.searchInput}
                  />
                ) : null}
                {!isRootDir ? (
                  <SortingPopover
                    values={CollectionUtil.ASSET_SORT_PARAMS.SORT_CRITERIAS}
                    selected={contextInfo.getSortCriteria()}
                    selectedOrder={contextInfo.getOrder()}
                    showOrder={true}
                    onClick={onSortCriteriaChanged}
                  />
                ) : null}
                <LayoutControls
                  layout={layout}
                  scale={scale}
                  onLayoutChange={onLayoutChange}
                  onScaleChange={onScaleChange}
                />
                <ActionMenu icon="images/settings.png" theme="WHITE" anchor="RIGHT" dismissOnClick>
                  <Button type="PLAIN" text={t('CONFIGURE_VIEW')} onClick={onConfigureClick} />
                  <div className="divider" />
                  {/* In Search mode not able to show Toggal button */}
                  <div style={globalSearchInfo.active ? { display: 'none' } : null}>
                    <Switch label={t('FOLDERNAV_MODE')} checked={showFolderNavView} onChange={this.toggleFolderNav} />
                    {showFolderNavView ? (
                      <Switch label={t('SHOW_TREE')} checked={showTreeView} onChange={this.toggleTreeView} />
                    ) : null}
                  </div>
                </ActionMenu>
              </div>
            }
          </div>
        </div>
      </div>
    );
  };

  renderMobileHeader = () => {
    const {
      categoryList,
      issueApplyFilter,
      resetFilters,
      mobileEditMode,
      onToggleMobileEditModeClick,
      assetsListBlockNode,
      showFolderNavView,
      showTreeView
    } = this.props;
    //const styles = getStyle();
    const { showActionSheet } = this.state;
    if (assetsListBlockNode) {
      const sticky = assetsListBlockNode.classList.contains('sticky');
      if (sticky) assetsListBlockNode.classList.add('mobile');
    }
    const hasDirtyFilters = (categoryList || []).filter((category) => category.isHasAnySelectedItem()).length > 0;
    return (
      <div className="assets-tab" name="AssetsListHeader">
        <Row center="H" align="SPREAD" className="header-1">
          <div className="center">
            <Button type="GRAY" onClick={this.toggleActionSheet}>
              {t('FILER_SORT')}
            </Button>
          </div>
        </Row>
        <Row center="H" align="SPREAD" className="header-2" style={!showTreeView ? { width: '100%', left: 0 } : null}>
          <Row center="H" className="left">
            <Button type="GRAY" onClick={onToggleMobileEditModeClick}>
              {mobileEditMode ? t('DONE') : t('SELECT_FILES')}
            </Button>
          </Row>
          {/* { mobileEditMode ? null : this.renderCollectionActions() } */}
          <div className="right">{mobileEditMode ? this.renderBulkActions() : this.renderLayoutControls()}</div>
        </Row>
        <ActionSheet show={showActionSheet} close={this.toggleActionSheet}>
          <div className="assets-tab" name="AssetsListHeader_ActionSheet">
            <div>
              <h3>{t('FILTER_LABEL')}</h3>
              {_.isEmpty(categoryList) ? null : (
                <div
                  className="header-1 flex-row align-center flex-wrap spc-between"
                  style={{ paddingBottom: '15px', overflow: 'hidden' }}>
                  <div className="filters flex-row align-center flex-wrap">
                    {_.map(categoryList, (category, index) => this.renderFilter(category, index))}
                    {hasDirtyFilters ? (
                      <Div
                        onClick={resetFilters}
                        title={t('CLEAR_ALL_FILTERS')}
                        className="clear"
                        style={{ color: 'var(--primary-style-color)', textDecoration: 'underline' }}>
                        {t('CLEAR_ALL_FILTERS')}
                      </Div>
                    ) : null}
                  </div>
                  <FiltersPopover issueApplyFilter={issueApplyFilter} />
                </div>
              )}
            </div>
            <div>
              <h3>{t('SORT')}</h3>
              {this.renderSort()}
            </div>
          </div>
        </ActionSheet>
      </div>
    );
  };

  render() {
    const screenSize = getScreenSize();
    switch (screenSize) {
      case ScreenSize.XS:
      case ScreenSize.SM:
      case ScreenSize.MD:
        return this.renderMobileHeader();
      default:
        return this.renderStandardHeader();
    }
  }
}

function getStyle() {
  return {
    resultsHeader: {
      height: '45px',
      color: '#B5B5B5',
      marginBottom: 5,
      position: 'relative'
    },
    switchViewButton: {
      cursor: 'pointer',
      backgroundRepeat: 'no-repeat',
      height: '18px',
      width: '18px',
      marginLeft: '20px'
    },
    starIcon: {
      width: '1.343em',
      height: '1.343em',
      backgroundImage: ThemeSetup.getBackgroundURL('star_empty.svg'),
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      position: 'absolute',
      right: '0',
      top: '.429em'
    },
    clear: {
      float: 'left',
      padding: '10px',
      color: '#EB6A5C',
      cursor: 'pointer',
      fontSize: '12px',
      height: '15px',
      width: '160px',
      fontFamily: 'Montserrat',
      fontWeight: '600',
      letterSpacing: '1px',
      lineHeight: '15px'
    },
    thumbnailSlider: {
      margin: 0,
      height: '18px'
    },
    thumbnailSliderWrapper: {
      overflow: 'hidden',
      transition: 'width 150ms ease-out'
    },
    configure: {
      width: 16,
      padding: 0,
      marginLeft: 20,
      overflow: 'hidden',
      transition: 'width 150ms ease-out'
    },
    noAssetFound: {
      color: '#3E3E3E',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translateX(-50%) translateY(-50%)',
      fontSize: '18px',
      lineHeight: '18px'
    },
    emptyPrompt: {
      color: '#3E3E3E',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translateX(-50%) translateY(-50%)',
      fontSize: '24px',
      lineHeight: '24px'
    },
    refresh: {
      padding: 0,
      height: '16px',
      width: '16px',
      cursor: 'pointer',
      margin: '2px'
      // position: 'absolute',
      // right: '-23px',
      // top: '2px'
    }
  };
}

export const InputSearch = function({ onInput, styleType = 'default', onSearchActive = _.noop, searchInput }) {
  const [value, setValue] = useState(searchInput);
  const [show, setShow] = useState(false);

  const toggleSearch = (isActive) => {
    onSearchActive(isActive);
    setShow(isActive);
  };

  const handleShortcut = (e: KeyboardEvent) => {
    if (e.ctrlKey && e.shiftKey && e.keyCode === KeyCode.F) {
      onInputValue({ target: { value: '' } });
      toggleSearch(true);
    }
    if (e.keyCode === KeyCode.ESCAPE && e.target.value) {
      onInputValue({ target: { value: '' } });
      toggleSearch(false);
    }
  };

  useEffect(() => {
    if (searchInput === undefined) {
      setValue('');
      toggleSearch(false);
    } else {
      toggleSearch(true);
    }
  }, [searchInput]);

  useEffect(() => {
    window.addEventListener('keyup', handleShortcut);
    return () => {
      window.removeEventListener('keyup', handleShortcut);
      //onInputValue({ target: { value: '' } });
    };
  }, [show]);

  const onInputValue = function(e) {
    setValue(e.target.value);
    onInput(e.target.value);
  };

  const onBlur = function() {
    if (!value) toggleSearch(false);
  };
  return styleType === 'default' ? (
    <div className="inputsearch">
      {!show ? <Button icon={ThemeSetup.getImageURL('search.svg')} onClick={() => toggleSearch(!show)} /> : null}
      {show ? (
        <div className="input-block">
          <input
            ref={(input) => {
              if (input) if (!input.value) input.focus();
            }}
            onBlur={onBlur}
            type="text"
            value={value}
            onChange={onInputValue}
          />
          <span className="cressIcon">
            <Button
              icon={ThemeSetup.getImageURL('cross.svg')}
              onClick={() => {
                onInputValue({ target: { value: '' } });
                toggleSearch(false);
              }}
            />
          </span>
        </div>
      ) : null}
    </div>
  ) : (
    <div className="inputsearch" style={{ position: 'relative', lineHeight: 0 }}>
      {!show ? <Button icon={ThemeSetup.getImageURL('search.svg')} onClick={() => toggleSearch(!show)} /> : null}
      {show ? (
        <div name="input-search-2">
          <input
            ref={(input) => {
              if (input) if (!input.value) input.focus();
            }}
            style={{ padding: '3px 20px 3px 5px', width: '100%' }}
            onBlur={onBlur}
            type="text"
            value={value}
            onChange={onInputValue}
          />
          <Button
            icon="images/cross_gray.svg"
            className="cross-btn"
            imgCls="btn-small"
            style={{ marginTop: 10 }}
            onClick={() => {
              onInputValue({ target: { value: '' } });
              toggleSearch(false);
            }}
          />
        </div>
      ) : null}
    </div>
  );
};
